import {
    WithStyles,
    withStyles,
    Button,
    Grid,
    FormControlLabel,
    RadioGroup,
    Radio,
  } from "@material-ui/core";
  import {
    Link,
  } from 'react-router-dom';
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import { userStyles } from '../../content-request/styles';
  import _, { filter } from 'lodash';
import MyPATLandingFilterCard from "../../common/MyPATLandingFilterCard";
  interface GoalManagementFilterProps {
    activeTab: string,
    filters:any,
    onChange:Function,
    classes:any,
    
  }
  interface GoalManagementFilterState {
    noDataPanel: boolean;
    filters:any,
    filteredGoals:any;
    inputValue:string;
  //  statusType:string;
  }
  
  class GoalManagementFilter extends Component<GoalManagementFilterProps, GoalManagementFilterState> {
    constructor(props: GoalManagementFilterProps) {
      super(props);
      this.state = {
        noDataPanel: false,
        filters:this.props.filters,
        filteredGoals:[],
        inputValue:'',
      
      };
    }
    componentDidMount(){
      const event = {
        target: {
          value: ''
        }
      }
  
    }
   
 
    handleStatusChange=(options:string)=>{
        this.props.onChange('status',options)
      }
      handleYearChange=(options:string)=>{
         this.props.onChange('year',options)
      }
    render() {
        const {filters,onChange,classes} = this.props;
      return (
        <Grid>
          <MyPATLandingFilterCard
                             filter={filters}
                             onChange={this.handleStatusChange}
                             title="Status"
                             valueKey="value"
                             labelKey="name"
                             name="status"/>     

                               <MyPATLandingFilterCard
                             filter={filters}
                             onChange={this.handleYearChange}
                             title="Target Year"
                             valueKey="value"
                             labelKey="name"
                             name="year"
                             istargetYear={true}/>   
        
        </Grid>
      );
    }
  }
  
  const mapStateToProps = (state: any) => ({
    goals: state.courseMangementData.courseManagementReducer.activeGoals,
  });
  
  const mapDispatchToProps = {
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
  )(withStyles(userStyles)(GoalManagementFilter));
  